import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes only meant for unauthenticated users (like /login).
 * If user is already authenticated (serviceToken exists), redirects to root /.
 */
export default function GuestGuard({ children }) {
  const token = localStorage.getItem('serviceToken');

  if (token) {
    return <Navigate to="/" replace />;
  }

  return children;
}

GuestGuard.propTypes = {
  children: PropTypes.node
};
